import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../../../context/LanguageContext';
import './BeforeAfter.css';

const BeforeAfter: React.FC = () => {
  const { t } = useLanguage();

  const beforeAfterImages = [
    {
      id: 1,
      before: '/assets/img/before-after/hasta-1.webp',
      after: '/assets/img/before-after/hasta-2.webp'
    },
    {
      id: 2,
      before: '/assets/img/before-after/hasta-3.webp',
      after: '/assets/img/before-after/hasta-4.webp'
    },
    {
      id: 3,
      before: '/assets/img/before-after/hasta-5.webp',
      after: '/assets/img/before-after/hasta-6.webp'
    },
    {
      id: 4,
      before: '/assets/img/before-after/hasta-7.webp',
      after: '/assets/img/before-after/hasta-8.webp'
    }
  ];

  return (
    <section id="before-after" className="before-after-section py-5">
      <Container>
        <Row className="mb-5">
          <Col className="text-center">
            <div className="luxury-title-container">
              <h2 className="luxury-section-title">{t('beforeAfter.title')}</h2>
              <div className="luxury-underline"></div>
            </div>
            <p className="luxury-subtitle">
              {t('beforeAfter.subtitle')}
            </p>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="before-after-gallery">
              <Row>
                {beforeAfterImages.map((imageSet, index) => (
                  <Col lg={6} md={12} className="mb-4" key={imageSet.id}>
                    <div className="before-after-card">
                      <div className="image-comparison">
                        <div className="image-container">
                          <div className="image-label before-label">
                            {t('beforeAfter.before')}
                          </div>
                          <img 
                            src={imageSet.before} 
                            alt={`${t('beforeAfter.before')} ${imageSet.id}`}
                            className="before-image img-fluid"
                          />
                        </div>
                        <div className="image-container">
                          <div className="image-label after-label">
                            {t('beforeAfter.after')}
                          </div>
                          <img 
                            src={imageSet.after} 
                            alt={`${t('beforeAfter.after')} ${imageSet.id}`}
                            className="after-image img-fluid"
                          />
                        </div>
                      </div>
                      <div className="case-info">
                        <span className="case-number">
                          {t('beforeAfter.case')} {imageSet.id}
                        </span>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="text-center mt-4">
            <div className="before-after-footer">
              <p className="note">
                <i className="fas fa-info-circle me-2"></i>
                {t('beforeAfter.note')}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BeforeAfter;
